import '@/lib/HorizontalScroller/horizontal-scroller.scss';
import { initHorizontalScroller } from '@/lib/HorizontalScroller';

// Initialize using the element method installed by the library
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mct-item-carousel').forEach(function (wrapper) {
    // ensure compatible hs-slider class is present on the slider element so the library styles apply
    var sliderEl = wrapper.querySelector('.mct-item-carousel-slider');

    if (sliderEl && !sliderEl.classList.contains('hs-slider')) {
        sliderEl.classList.add('hs-slider');
    }

    // initialize HorizontalScroller using the element API (no selector needed)
    wrapper.HorizontalScroller();

    // Set the first tab as active on page load
    setTab(wrapper.closest('.control-mini-card-tabs').querySelector('.mct-nav-item'));
  });



  document.querySelectorAll('.mct-nav-item').forEach(function (wrapper) {
    wrapper.addEventListener('click', function (e) {
        e.preventDefault();
        setTab(wrapper);
    });
  });

  function setTab(wrapper) {
        // toggle active state on clicked nav item
        wrapper.parentElement.querySelectorAll('.mct-nav-item').forEach(function (navItem) {
            navItem.classList.toggle('active', navItem === wrapper);
        });
        const targetTab = wrapper.dataset.tab; // get target from data attribute
        // Hide all mini-card items and show only those matching the target tab
        wrapper.closest('.control-mini-card-tabs').querySelectorAll('.mct-items').forEach(function (card) {
            const matchesTab = card.dataset.tab === targetTab; // check if card matches target tab
            card.classList.toggle('active', matchesTab); // toggle active class based on match
        });

        // Update the horizontal scroller to recalculate dimensions after showing/hiding items
        const scroller = wrapper.closest('.control-mini-card-tabs').querySelector('.mct-item-carousel');

        const scrollerEle = scroller.HorizontalScroller().update();
  }

});
